// AI-generated: DNA 2026 wordmark with WebP preferred and PNG fallback. 2026-10-15
import dnaLogoWebp from "@/assets/brand/dna-logo-2026.webp";
import dnaLogoPng from "@/assets/brand/dna-logo-2026.png";

type DnaLogoProps = {
  height?: number;
  maxWidth?: number;
  style?: React.CSSProperties;
};

export function DnaLogo({ height = 32, maxWidth, style }: DnaLogoProps) {
  return (
    <picture>
      <source srcSet={dnaLogoWebp} type="image/webp" />
      <img
        src={dnaLogoPng}
        alt="Don Norman Associates"
        style={{
          height,
          width: "auto",
          maxWidth,
          display: "block",
          ...style,
        }}
      />
    </picture>
  );
}
